import "./InlineLoadingIcon.scss";

export function InlineLoadingIcon() {
  return (
    <div className="inline-loading-icon">
      <span className="material-symbols-outlined">refresh</span>
    </div>
  );
}
